import { t } from '@lingui/core/macro';
import { SearchStringFilter } from './SearchStringFilter';
import { useGetComposers } from './useGetComposers';
export const composerFilterLabel = () => t({ message: 'Template', comment: 'Insights filter: Template' });
export function ComposerFilter() {
    const { composers, loading, error } = useGetComposers();
    const disabled = Boolean(loading || error);
    return (<SearchStringFilter name="metadataDocumentComposerId" items={composers} label={composerFilterLabel()} loading={disabled}/>);
}
